import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money, errMsg } from "../../lib/api";
import { Loading } from "../../components/PageHeader";
import { AdminTitle, Pill, ORDER_TONE, ErrorBox } from "./AdminLayout";
import { SalesCharts } from "./Charts";

const Stat = ({ label, value, testid, to }) => (
  <Link to={to} className="wb-card p-6 transition-colors hover:border-[color:var(--wb-line-accent)]" data-testid={testid}>
    <div className="wb-label">{label}</div>
    <div className="mt-3 font-display text-4xl gold">{value}</div>
  </Link>
);

export default function Overview() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, []);
  if (err) return <ErrorBox msg={err} />;
  if (!d) return <Loading />;
  return (
    <div data-testid="admin-overview">
      <AdminTitle eyebrow="Overview" title="The studio at a glance">
        <Link to="/admin/products/new" className="btn-gold" data-testid="overview-new-product-button">New product</Link>
      </AdminTitle>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <Stat label="Total revenue" value={money(d.revenue)} testid="stat-revenue" to="/admin/orders" />
        <Stat label="Paid orders" value={d.paid_orders} testid="stat-orders" to="/admin/orders" />
        <Stat label="Awaiting shipment" value={d.awaiting_shipment} testid="stat-awaiting" to="/admin/orders?status=paid" />
        <Stat label="Unread messages" value={d.unread_messages} testid="stat-messages" to="/admin/messages" />
        <Stat label="Products" value={d.products} testid="stat-products" to="/admin/products" />
        <Stat label="Users" value={d.users} testid="stat-users" to="/admin/users" />
        <Stat label="Pending approval" value={d.pending_users} testid="stat-pending-users" to="/admin/users?status=pending" />
      </div>
      <SalesCharts />
      <div className="mt-12 grid gap-8 xl:grid-cols-2">
        <div className="wb-card p-6" data-testid="low-stock-panel">
          <div className="eyebrow mb-5">Low & sold-out stock</div>
          {d.low_stock.length === 0 ? <p className="text-sm muted">All originals are well stocked.</p> : d.low_stock.map((p) => (
            <Link key={p.id} to={`/admin/products/${p.id}`} className="flex items-center justify-between border-b wb-line py-3 text-sm hover:text-wb-gold" data-testid={`low-stock-${p.slug}`}>
              <span>{p.title}</span>
              {p.stock <= 0 ? <Pill tone="red">Sold out</Pill> : <Pill tone="gold">{p.stock} left</Pill>}
            </Link>
          ))}
        </div>
        <div className="wb-card p-6">
          <div className="eyebrow mb-5">Recent paid orders</div>
          {d.recent_orders.length === 0 ? <p className="text-sm muted">No orders yet.</p> : d.recent_orders.map((o) => (
            <Link key={o.id} to={`/admin/orders/${o.id}`} className="flex items-center justify-between gap-4 border-b wb-line py-3 text-sm hover:text-wb-gold">
              <span className="font-mono text-xs">{o.order_number}</span>
              <span className="truncate muted">{o.email}</span>
              <Pill tone={ORDER_TONE[o.status]}>{o.status}</Pill>
              <span className="font-mono">{money(o.amount_paid ?? o.total)}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
